import React, { useState } from 'react';
import USBButton from '@usb-shield/react-button';
import USBModal, { ModalBody, ModalFooter, ModalHeader } from '@usb-shield/react-modal';
import './SessionTimerPopUp.css';
import { Typography } from '@mui/material';



interface SessionTimerPopUpProps {
  isOpen: boolean;
  countdown: any; // seconds
  onContinue: () => void;
  onLogout: () => void;
}



const SessionTimerPopUp: React.FC<SessionTimerPopUpProps> = ({ isOpen, countdown, onContinue, onLogout }) => {

  return (
    <USBModal
      id="modal-basic"
      isOpen={isOpen}
      hasCloseIconButton={false}
      handleClose={() => {}}
      addClasses='modelBasic'
    >
      <ModalHeader id="modal-basic-header">Session timeout</ModalHeader>
      <ModalBody>
        Your session is about to time out. Please click continue to stay logged in, or click log out to be immediately logged out.
      </ModalBody>
      <Typography className='modelTimer'>{countdown}</Typography>
      <ModalFooter>
        <USBButton
          id="modal-basic-continue-button"
          ctaStyle="standard"
          emphasis="heavy"
          onPress={onContinue}
        >
          Continue
        </USBButton>
        <USBButton
          id="modal-basic-logout-button"
          ctaStyle="standard"
          emphasis="subtle"
          onPress={onLogout}
        >
          Log out
        </USBButton>
      </ModalFooter>
    </USBModal>
  );
};

export default SessionTimerPopUp;